import { render, staticRenderFns } from "./end-game.vue?vue&type=template&id=a3ca3210&scoped=true&"
import script from "./end-game.vue?vue&type=script&lang=js&"
export * from "./end-game.vue?vue&type=script&lang=js&"
import style0 from "./end-game.vue?vue&type=style&index=0&id=a3ca3210&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ca3210",
  null
  
)

export default component.exports